module.exports = __webpack_public_path__ + "img/logocalce-new.0596b079.png";